<template>
  <el-form size="small" label-width="100px" :rules="rules" ref="huikuform" :model="form">
    <el-row>
      <el-col :span="8">
        <el-form-item label="项目或工地" prop="contract" :rules="{ required: true, message: '请输入合同编号或工地', trigger: 'blur' }">
          <el-select
            v-model="form.contract"
            filterable
            remote
            placeholder="项目或工地"
            :remote-method="remoteMethod"
            @change="selectContract"
            :loading="loading"
          >
            <el-option v-for="item in XiangmuGongdiOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="所属仓库" prop="cangku">
          <el-select v-model="form.cangku" placeholder="请选择所属仓库">
            <el-option v-for="item in cangkus_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="回库时间" prop="date">
          <el-date-picker type="date" :picker-options="pickerOptions" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="form.date" style="width: 100%;">
          </el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-for="(huiku, index) in form.huikus" :key="huiku.key">
      <el-col :span="24">
        <el-row>
          <el-col :span="6">
            <el-form-item label="材料名称" :prop="'huikus.' + index + '.cailiao_id'" :rules="{ required: true, message: '请选择材料名称', trigger: 'blur' }">
              <el-select v-model="huiku.cailiao_id" placeholder="材料名称" @change="selectCailiao(index)">
                <el-option v-for="item in cailiaos_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="材料规格"
              :prop="'huikus.' + index + '.cailiaoguige_id'"
              :rules="{ required: true, message: '请选择材料规格', trigger: 'blur' }"
            >
              <el-select v-model="huiku.cailiaoguige_id" placeholder="材料规格" @change="selectCailiaoguige(index)">
                <el-option v-for="item in cailiaoguiges_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item
              label="回库数量"
              :prop="'huikus.' + index + '.amount'"
              :rules="
                ({ required: true, message: '请输入数量', trigger: 'blur' },
                { type: 'number', message: '数量必须为数字' },
                {
                  validator: (rule, value, callback) => {
                    validateLeftamount(rule, value, callback, ingongdi[index])
                  },
                  trigger: 'blur'
                })
              "
            >
              <el-input v-model.number="huiku.amount"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item
              label="待修数量"
              :prop="'huikus.' + index + '.daixiu_amount'"
              :rules="({ required: true, message: '请输入数量', trigger: 'blur' }, { type: 'number', message: '数量必须为数字' })"
            >
              <el-input v-model.number="huiku.daixiu_amount"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-button size="small" @click.prevent="removeDomainHuiku(huiku)">删除</el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item>
              <span style="color:red">工地总数量：{{ sum_ingongdi[index] }} </span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <span style="color:blue">在工地数量：{{ ingongdi[index] }} </span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item>
          <el-button @click="addDomainHuiku" type="success" plain>添加下一笔回库</el-button>
        </el-form-item>
      </el-col></el-row
    >

    <el-row>
      <el-col :span="24">
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" rows="3"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item>
      <el-form-item label="上传图片：" prop="photos">
        <el-upload
          class="upload-demo"
          ref="upload"
          action="http://ln-jz.cn:8000/uploadImg/"
          multiple
          accept="image/png, image/jpeg,image/gif"
          list-type="picture"
          :on-remove="handleRemove"
          :file-list="fileList"
          :before-upload="beforeUploadPicture"
          :on-success="uploadSuccess"
          :auto-upload="false"
        >
          <div slot="tip" class="el-upload__tip">只能上传jpg/png/gif文件，且单个文件不超过10M</div>
          <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
        </el-upload>
      </el-form-item>
      <div style="float:right;">
        <el-button @click="resetForm('huikuform')"> 取消 </el-button>
        <el-button type="primary" @click="submitForm('huikuform')"> 确认添加 </el-button>
      </div>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: {
    isShowHeyueField: Boolean
  },
  data() {
    return {
      form: {
        huikus: [
          {
            cailiao_id: '',
            cailiaoguige_id: '',
            amount: 0,
            daixiu_amount: 0
          }
        ]
      },
      sum_ingongdi: [],
      ingongdi: [],
      fileList: [],
      file_count: 0,
      XiangmuGongdiOptions: [],
      cangkus_options: [],
      cailiaos_options: [],
      cailiaoguiges_options: [],
      loading: false,

      rules: {
        cangku: [{ required: true, message: '请选择所属仓库', trigger: 'blur' }],
        cailiao: [{ required: true, message: '请选择材料名称', trigger: 'blur' }],
        cailiaoguige: [{ required: true, message: '请选择材料规格', trigger: 'blur' }],
        amount: [{ required: true, message: '请输入数量', trigger: 'blur' }, { type: 'number', message: '数量必须为数字' }],
        daixiu_amount: [{ required: true, message: '请输入数量', trigger: 'blur' }, { type: 'number', message: '数量必须为数字' }],
        date: [{ required: true, message: '请选择调配时间', trigger: 'blur' }]
      },
      pickerOptions: {
        // 限制只能选择今天之前的日期
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },

  methods: {
    validateLeftamount(rule, value, callback, ingongdi) {
      if (value > ingongdi) {
        callback(new Error('回库数量超出在工地数量！'))
      } else {
        callback()
      }
    },
    //项目工地搜索框响应事件，从后台查询10条记录
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          const api = '/getXiangmuGongdis/'
          this.$axios
            .get(api, {
              params: {
                query: query
              }
            })
            .then(res => {
              if (res.data.code === 1000) {
                this.XiangmuGongdiOptions = res.data.data.map(item => {
                  item.label = item.contract_id + item.project
                  item.value = item.id
                  return item
                })
              } else {
                console.log('没有项目工地信息！')
              }

              console.log('XiangmuGongdiOptions', this.XiangmuGongdiOptions)
            })
        }, 200)
      } else {
        this.XiangmuGongdiOptions = []
      }
    },

    getCangkus() {
      this.cangkus_options = []

      this.$axios.get('/getCangkus/').then(res => {
        console.log('getCangkus list:', res.data)
        res.data.forEach(element => {
          let cangku = {}
          cangku.label = String(element.name)
          cangku.value = element.id
          this.cangkus_options.push(cangku)
        })
        console.log('cangkus_options', this.cangkus_options)
      })
    },
    getCailiaos() {
      this.$axios.get('/getCailiaos/').then(res => {
        console.log('getCailiaos list:', res.data)
        res.data.forEach(element => {
          let cailiao = {}
          cailiao.label = String(element.name)
          cailiao.value = element.id
          this.cailiaos_options.push(cailiao)
        })
        console.log('cailiaos_options', this.cailiaos_options)
      })
    },
    getCailiaoguiges() {
      this.$axios.get('/getCailiaoguiges/').then(res => {
        console.log('getCailiaoguiges list:', res.data)
        res.data.forEach(element => {
          let cailiaoguige = {}
          cailiaoguige.label = String(element.name)
          cailiaoguige.value = element.id
          this.cailiaoguiges_options.push(cailiaoguige)
        })
        console.log('cailiaoguiges_options', this.cailiaoguiges_options)
      })
    },
    //增加回库表单域
    addDomainHuiku() {
      this.form.huikus.push({
        cailiao_id: '',
        cailiaoguige_id: '',
        amount: 0,
        daixiu_amount: 0,
        key: Date.now()
      })
    },

    //删除回库表单域
    removeDomainHuiku(huiku) {
      var index = this.form.huikus.indexOf(huiku)
      if (index !== -1) {
        this.form.huikus.splice(index, 1)
      }
    },
    //提交表单
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.file_count < 1) {
            console.log('fileList_len:', this.fileList.length)
            this.$message({
              type: 'alert',
              message: '请至少上传1张图片!',
              duration: 2000
            })
          } else {
            console.log('validation ok!')
            console.log('this.contract........:', this.form.contract)
            this.$emit('submitForm', this.form)
            this.ClearForm()
          }
        } else {
          console.log('Validation error!')
          return false
        }
      })
    },
    //清空表单
    ClearForm() {
      this.form = {
        huikus: [
          {
            cailiao_id: '',
            cailiaoguige_id: '',
            amount: 0,
            daixiu_amount: 0
          }
        ]
      }
      this.fileList = []
      this.file_count = 0
      this.ingongdi = []
      this.sum_ingongdi = []
    },

    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.ClearForm()
      this.$emit('resetForm')
    },
    // 上传图片前调用方法
    beforeUploadPicture(file) {
      if (file.size > 10 * 1024 * 1024) {
        this.$message.error('上传图片不能大于10M')
        return false
      }
    },
    // 上传图片成功
    uploadSuccess(res, file, fileList) {
      this.file_count += 1
      this.fileChange(fileList)
      console.log('uploadfilelist.len:', fileList.length)
      console.log('file_count:', this.file_count)
    },
    // 移除图片
    handleRemove(file, fileList) {
      console.log('RemovefileList', fileList)
      this.fileChange(fileList)
    },
    // 设置photo字段值
    fileChange(fileList) {
      let temp_str = ''
      this.file_count = fileList.length
      if (fileList.length > 0) {
        for (let i = 0; i < fileList.length; i++) {
          if (i === 0) {
            //列表中的第一个,作为temp_str的第一个元素
            if (fileList[i].response) {
              //新上传成功的
              console.log('file response:', fileList[i].response)
              if (fileList[i].response.code === 1000) {
                // temp_str += '/api/' + fileList[i].response.data //本地
                temp_str += fileList[i].response.data //服务器
              }
            } else {
              //原来已上传的，url已处理成“/api/...."格式
              temp_str += fileList[i].url
            }
          } else {
            //不是列表中的第一个,插入到temp_str中
            if (fileList[i].response) {
              //新上传成功的
              console.log('file response:', fileList[i].response)
              if (fileList[i].response.code === 1000) {
                // temp_str += ',' + '/api/' + fileList[i].response.data //本地
                temp_str += ',' + fileList[i].response.data //服务器
              }
            } else {
              //原来已上传的，url已处理成“/api/...."格式
              temp_str += ',' + fileList[i].url
            }
          }
        }
      }
      this.form.photos = temp_str
      console.log('photos:', this.form.photos)
    },
    submitUpload() {
      this.$refs.upload.submit()
    },
    // typeof this.form.contract === 'undefined'
    selectContract() {
      // this.form = {}
    },
    selectCailiao(index) {
      this.getIngongdibyContract(index)
    },
    selectCailiaoguige(index) {
      this.getIngongdibyContract(index)
    },
    getIngongdibyContract(index) {
      console.log('this.form.contract', this.form.contract)
      console.log('this.form.huikus[index].cailiao_id', this.form.huikus[index].cailiao_id)
      console.log('this.form.huikus[index].cailiaoguige_id', this.form.huikus[index].cailiaoguige_id)
      if (
        typeof this.form.contract != 'undefined' &&
        typeof this.form.huikus[index].cailiao_id != 'undefined' &&
        typeof this.form.huikus[index].cailiaoguige_id != 'undefined' &&
        this.form.huikus[index].cailiao_id != '' &&
        this.form.huikus[index].cailiaoguige_id != ''
      ) {
        const api = '/getIngongdibyContract/'
        this.$axios
          .get(api, {
            params: {
              contract: this.form.contract,
              cailiao: this.form.huikus[index].cailiao_id,
              cailiaoguige: this.form.huikus[index].cailiaoguige_id
            }
          })
          .then(res => {
            this.$set(this.sum_ingongdi, index, res.data.sum_ingongdi)
            this.$set(this.ingongdi, index, res.data.ingongdi)
            console.log('res.data.sum_ingongdi:', res.data.sum_ingongdi)
            console.log('res.data.ingongdi:', res.data.ingongdi)
          })
      }
    }
  },
  created() {
    this.getCangkus()
    this.getCailiaos()
    this.getCailiaoguiges()
  }
}
</script>

<style scoped></style>
